import React, { memo, forwardRef } from "react";
const SvgParentheses1 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M18.147 21.939h0a20.44 20.44 0 00.977-6.24c0-2.117-.326-4.189-.977-6.214-.65-2.043-1.51-3.825-2.578-5.346h0c-.229-.324-.508-.502-.838-.502a.908.908 0 00-.663.27.822.822 0 00-.274.64c0 .206.082.431.23.673h0l.002.002c.949 1.468 1.7 3.115 2.256 4.943h0v.001c.574 1.827.86 3.67.86 5.532s-.286 3.706-.86 5.532v.001c-.555 1.828-1.307 3.475-2.256 4.943h0l-.001.002c-.15.242-.231.467-.231.673 0 .259.09.476.274.64.181.18.404.27.663.27.33 0 .61-.178.838-.501h0c1.068-1.522 1.928-3.295 2.578-5.32z"
      />
    </svg>
  );
});
SvgParentheses1.displayName = "SvgParentheses1";
const MemoForwardRef = memo(SvgParentheses1);
export default MemoForwardRef;
